import React from "react";
import Helmet from "react-helmet";

import styled from "styled-components";
import { COLORS } from "../common/style";

import { Link } from "react-router-dom";

import Prism from "prismjs";
//Prism Theme Style
import "prismjs/themes/prism-dark.css";

import { ButterflyEditor } from "butterfly-editor";
import "butterfly-editor/dist/style.css";

const OverviewContainer = styled.div`
  width: 100%;
  height: 29em;
  /* max-height: 30em; */
  position: relative;
`;

const DiagnolWrapper = styled.div`
  width: 100%;
  height: 100%;
  /*clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 50%);*/
  &:before {
    width: 100%;
    height: 173%;
    width: 100%;
    /* height: 150%; */
    background-image: linear-gradient(to right, #5a90fd, #702aff);
    transform: skewY(-5deg);
    content: "";
    /*overflow: visible;*/
    position: absolute;
    top: -10em;
    left: 0;
    z-index: -1;
  }
`;

const Centered = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: 600;
  font-size: ${({ size }) => (size ? size : 18)}px;
  font-family: Oxygen, sans-serif;
  position: relative;
  color: ${({ color }) => (color ? color : `#fff`)};
  justify-content: center;
  align-items: center;
  text-shadow: ${({ textShadow }) =>
    textShadow ? `3px 3px 8px rgba(15, 15, 15, 0.4)` : undefined};
  top: ${({ top }) => (top ? `${top}%` : `50%`)};
  transform: ${({ offsetTop }) =>
    offsetTop ? `translateY(-${offsetTop}%)` : `translateY(-50%)`};
`;
const DocsButton = styled.button`
  border: 0;
  border-bottom: 2px solid #f1c40f;
  background: ${COLORS.mainThemeColor};
  color: #fff;
  padding: 5px 17px;
  border-radius: 4px;
  transition: background-color, 160ms ease-in-out;
  cursor: pointer;
  outline: none;
  &:hover {
    background-color: transparent;
  }
`;

const GithubButton = styled.div`
  border: 0;
  border-bottom: 2px solid #f1c40f;
  background: ${COLORS.mainThemeColor};
  color: #fff;
  padding: 5px 17px;
  border-radius: 4px;
  transition: background-color, 160ms ease-in-out;
  cursor: pointer;
  outline: none;
  margin-left: 15px;
  &:hover {
    background-color: #e74c3c;
  }
`;

const BTFlyEditorWrapper = styled.div`
  /*min-width: 35em;
  min-height: 20em;
  background-color: ${COLORS.mainThemeColor};*/
`;

const QuickSetupContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 9em;
  display: flex;
  flex-direction: column;
  padding: 0 3em;
`;

const SnippetCode = styled.pre`
  background-color: #353b48;
  border: 1px solid #fff;
  border-radius: 4px;
  /*max-width: 60em;*/
  overflow-x: auto;
  & > code {
    color: #fff;
  }
`;

const DemoContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IndexPage = () => {
  //React Environment Editor Setup Code Snippets
  const quickSetupCode = `import EditorCreator, { EditorComponent } from "butterfly-editor";\nimport "butterfly-editor/dist/style.css"; \n\nexport default class App extends React.Component {
    constructor(props) {
      super(props);
      this.editorConfig = {
        allowEditorFullExpand: true,
        allowHTMLExport: true
      };
    }
  
    componentDidMount() {
      //Register OnChange Callback for listening for new text & HTML changes on the Butterfly Editor
      this.textEditor.onChange((text, html) => {
        console.log("Editor Text Changed: ", text, html);
      });
    }
  
    render() {
      return (
        <EditorComponent
          config={this.editorConfig}
          editorRef={ref => (this.textEditor = ref)}
        />
      );
    }
  }`;
  //Use Prism Syntax Highlighter to Colorize the Code Snippet
  const html = Prism.highlight(
    quickSetupCode,
    Prism.languages.javascript,
    "javascript"
  );

  return (
    <>
      <Helmet />
      <OverviewContainer className="overview-container">
        <DiagnolWrapper className="diagnolWrapper">
          <Centered className="centered" size={25} top={20} textShadow>
            Explore a New Way of Rich Text Editing
          </Centered>
          <Centered className="centered" top={30}>
            <div id="butterfly-text">Butterfly Editor</div>
          </Centered>
          <Centered className="centered" top={35}>
            <DocsButton>
              <Link to="/docs/">Docs</Link>
            </DocsButton>
            <GithubButton>
              <a href="https://github.com/ipenywis/ButterflyEditor">Github</a>
            </GithubButton>
          </Centered>
          <Centered className="centered" size={25} top={50} textShadow>
            Editor Demo
          </Centered>
          <Centered className="centered" top={90} />
        </DiagnolWrapper>
      </OverviewContainer>
      <DemoContainer className="demo-container">
        <ButterflyEditor config={{ allowEditorFullExpand: false }} />
      </DemoContainer>
      <QuickSetupContainer className="quick-setup-container">
        <Centered className="centered" size={22} color={COLORS.mainThemeColor}>
          Quick Start with React
        </Centered>
        <SnippetCode className="snippet-code">
          <code dangerouslySetInnerHTML={{ __html: html }} />
        </SnippetCode>
      </QuickSetupContainer>
    </>
  );
};

//#FAFBFC

export default IndexPage;
